export default "__VITE_ASSET__COeSR0OK__"